/*export default angular.module('iscroll.module', [])
	.directive('iscroll', [function(){
		return {
			link: function(scope, element, attrs){

				var offset = parseInt(attrs.threshold) || 0;
				var e = element[0];
				e.scrollTop = 0;

				console.log( '-->',e.scrollTop, e.offsetHeight, offset);
				
				element.bind('scroll', function(){
					console.log( '-->',e.scrollTop + e.offsetHeight >= e.scrollHeight - offset);
					if( e.scrollTop + e.offsetHeight >= e.scrollHeight - offset ){
						scope.$apply(attrs.handle);
					}
				});

			}
		};
	}])
	.name;*/


import angular from 'angular';
import controller from './controller';
//import styles from './styles.less';
//import template from './template.pug'

export default angular.module('bfunc.components.infinite-scroll', [])

	.component('iscroll', {
		//template: '<h1>O</h1>',
		controller: controller,
		controllerAs: 'ctrl',
		bindings: {
			busy: '<',
			onUpdate: '&'
		}
	})
.name;


/** WEBPACK FOOTER **
 ** ./src/components/infinite-scroll/index.js
 **/